<template>
  <div>{{ $t('src/pages/home.index') }}</div>
</template>

<script>
export default {
  name: 'HomePage',
  components: {},
  computed: {},
  created() {
    if (this.isNeuroAdmin) {
      this.$router.push('/hospitals')
    } else {
      this.$router.push('/courses')
    }
  }
}
</script>
